import React from 'react';
import PropTypes from "prop-types";

import { Col } from "react-bootstrap";
import Image from "components/Image";

import "./BrandItem.scss";

const BrandItem = ({imageFileName, header, url}) => {
  return (
    <Col md={4} sm={6} className="brand-item text-center ">
      <Image
        className="img-fluid rounded-circle border mb-3"
        fileName={imageFileName}
        alt={header}
      />
      <div>
      <h4 className="brand-header">
        { url ? (
          <a target="_blank" rel="noopener noreferrer" href={url}>
            { header }
          </a>
          ) :
          header
        }
      </h4>
      </div>
    </Col>
  );
};

BrandItem.propTypes = {
  imageFileName: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  url: PropTypes.string,
}

BrandItem.defaultProps = {
  url: null,
}

export default BrandItem;